import { API_KEY, API_URL_WITHOUT_USER } from "../../Utils/API";
import {
  getDispatch,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../Utils/helper";
import { HttpUtil } from "../../Utils/http-utils";
import {
  GET_SKU_TEST_PACKAGES_DETAILS,
  GET_TOTAL_COUNT,
  getNetworkMenuId,
  getToken,
  GET_PROVIDERLIST_DETAIL,
  GET_TAGLIST_NETWORK,
  GET_FACILITY_DROPDOWNlIST,
} from "../../Utils/types";

export const getSkuTestPackagesNetworkAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkSkuPackage/GetSkuDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      isLoadingAction(false, dispatch);
      getDispatch(GET_SKU_TEST_PACKAGES_DETAILS, res?.data?.results, dispatch);
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
    } else {
      isLoadingAction(false, dispatch);
      getDispatch(GET_SKU_TEST_PACKAGES_DETAILS, res?.data?.results, dispatch);
    }
  });
};

export const getNetworkSKUTestDetailByIdAction = (e) => () => {
  const url = `${API_URL_WITHOUT_USER}/NetworkSkuPackage/AddUpdateSkuTestGETNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getNetworkMenuId()?.menuId,
  });
};

export const addProviderNetworkSKUTestAction = (e) => () => {
  const url = `${API_URL_WITHOUT_USER}/NetworkSkuPackage/AddUpdateSkuTestNetwork`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getNetworkMenuId()?.menuId,
  });
};

export const getSkuPackagesNetworkAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkSkuPackage/UspGetPackageDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      isLoadingAction(false, dispatch);
      getDispatch(GET_SKU_TEST_PACKAGES_DETAILS, res?.data?.results, dispatch);
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
    } else {
      isLoadingAction(false, dispatch);
      getDispatch(GET_SKU_TEST_PACKAGES_DETAILS, res?.data?.results, dispatch);
    }
  });
};

export const getNetworkSKUPackageDetailByIdAction = (e) => () => {
  const url = `${API_URL_WITHOUT_USER}/NetworkSkuPackage/AddUpdatePackageGETNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getNetworkMenuId()?.menuId,
  });
};

export const addProviderNetworkSKUPackageAction = (e) => () => {
  const url = `${API_URL_WITHOUT_USER}/NetworkSkuPackage/AddUpdatePackageNetwork`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getNetworkMenuId()?.menuId,
  });
};

export const getProviderListNetworkAction = (type) => (dispatch) => {
  // isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkSkuPackage/GetProviderListNetwork`;
  return HttpUtil.makePOST(
    url,
    {
      providerId: 0,
      providerName: "",
    },
    {
      ApiKey: API_KEY,
      Authorization: getToken(),
      MenuId: getNetworkMenuId()?.menuId,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_PROVIDERLIST_DETAIL, res?.data?.results, dispatch);
      // isLoadingAction(false, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
      getDispatch(GET_PROVIDERLIST_DETAIL, {}, dispatch);
      // isLoadingAction(false, dispatch);
    }
  });
};

export const getAllProviderListNetworkAction = (type) => (dispatch) => {
  // isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkSkuPackage/GetProviderListNetwork`;
  return HttpUtil.makePOST(
    url,
    {
      providerId: 0,
      providerName: "",
      showAll:true
    },
    {
      ApiKey: API_KEY,
      Authorization: getToken(),
      MenuId: getNetworkMenuId()?.menuId,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_PROVIDERLIST_DETAIL, res?.data?.results, dispatch);
      // isLoadingAction(false, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
      getDispatch(GET_PROVIDERLIST_DETAIL, {}, dispatch);
      // isLoadingAction(false, dispatch);
    }
  });
};

export const getSKUPackageNetworkExcelAction = (e) => () => {
  const url = `${API_URL_WITHOUT_USER}/NetworkSkuPackage/ExportToExcelPackageDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
  });
};



export const getTagListNetworkAction = () => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/NetworkSkuPackage/GetTagListNetwork`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      ApiKey: API_KEY,
      Authorization: getToken(),
      MenuId: getNetworkMenuId()?.menuId,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_TAGLIST_NETWORK, res?.data?.results, dispatch);
    } else {
      getDispatch(GET_TAGLIST_NETWORK, {}, dispatch);
    }
  });
};
export const GetFacilityDropDownList = () => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/NetworkSkuPackage/GetFacilityDropDownList`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      // ApiKey: API_KEY,
      Authorization: getToken(),
      MenuId:getNetworkMenuId()?.menuId,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_FACILITY_DROPDOWNlIST, res?.data?.results, dispatch);
    } else {
      getDispatch(GET_FACILITY_DROPDOWNlIST, [], dispatch);
    }
  });
};

export const activeInactiveTestPackageNetworkAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkSkuPackage/ChangeTestPackageMappingStatusNetwork`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getSnackbarSuccess("success", res?.data?.message, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};